import { reportEndpoints } from './report'
import { adminEndpoints } from './admin'
import { authEndpoints } from './auth'
import { noteEndpoints } from './notes'
import { env } from '@/config/runtime-env'

export const apiBase = env.VUE_APP_API_BASE

export const apiEndpoints = {
  ...authEndpoints,
  reports: reportEndpoints,
  notes: noteEndpoints,
  admin: adminEndpoints
}
